import _ from 'lodash'

import {
    LIENS_DEBTOR_TABLE_CHANGE,
    LIENS_DEBTOR_TABLE_CHANGE_REQUEST,
    LIENS_DEBTOR_TABLE_LOADING_TRUE,
    LIENS_DEBTOR_TABLE_LOADING_FALSE,
    LIENS_DEBTOR_TABLE_DATA_RECEIVED,
} from './constants'

import config from '../../../../../../../../../../../../../config'

export function debtorTableChange(module, block, id, level, customData, qs) {
    return {
        type: LIENS_DEBTOR_TABLE_CHANGE,
        data: {
            module,
            block,
            id,
            level,
            customData,
            qs,
        },
    }
}

export function debtorTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: LIENS_DEBTOR_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${blockKey}.block[3].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function debtorsTableLoadingTrue(module, block, id, customData) {
    return {
        type: LIENS_DEBTOR_TABLE_LOADING_TRUE,
        data: {
            module,
            blockKey: block,
            id,
            customData,
        },
    }
}

export function debtorsTableLoadingFalse(module, block, id, customData) {
    return {
        type: LIENS_DEBTOR_TABLE_LOADING_FALSE,
        data: {
            module,
            blockKey: block,
            id,
            customData,
        },
    }
}

export function debtorsTableDataReceived(module, block, id, customData) {
    return {
        type: LIENS_DEBTOR_TABLE_DATA_RECEIVED,
        data: {
            module,
            blockKey: block,
            id,
            customData,
        },
    }
}
